/**
 * A tab left open across a deploy keeps running the bundle it loaded, with
 * the old wording and the old links, until someone reloads it - the page
 * shell is served with max-age 0 but a single-page app never asks for it
 * again on its own (2026-09-16: an attention item still pointed at Add
 * stats an hour after the fix shipped). The header fetches the shell once a
 * minute and compares the hashed bundle it names with the one the tab is
 * running: a different name is a newer build. No server change, no build
 * plumbing: the hash IS the version.
 */
const BUNDLE = /assets\/index-[A-Za-z0-9_-]+\.js/;

/** The bundle a page shell names, or null when it names none. */
export function bundleOf(html: string): string | null {
  const m = BUNDLE.exec(html);
  return m ? m[0] : null;
}

/** The bundle this tab is running, from its own script tag; null in dev (no hashed bundle). */
export function runningBundle(doc: Pick<Document, 'querySelector'> = document): string | null {
  const script = doc.querySelector('script[src*="/assets/index-"]') as { src?: string } | null;
  return script?.src ? bundleOf(script.src) : null;
}

/** True when the served shell names a bundle other than the running one; never true without both. */
export function newerBuildAvailable(served: string | null, running: string | null): boolean {
  return !!served && !!running && served !== running;
}

/** The served shell's bundle, fetched past every cache. */
export async function servedBundle(): Promise<string | null> {
  const res = await fetch('/', { cache: 'no-store', headers: { accept: 'text/html' } });
  if (!res.ok) return null;
  return bundleOf(await res.text());
}
